import {
  Box,
  Circle,
  Divider,
  Flex,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Custom_Button from "../Button/Custom_Button";
import Status_Component from "../Status/Status_Component";
import * as api from "../../../services/api";
import moment from "moment";
import profile from "../../../Assets/newProfile.svg";
import message from "../../../Assets/message-1.png";

const SentInvite_Page = ({ data }) => {
  const navigate = useNavigate();
  const [inviteData, setInviteData] = useState([]);
  useEffect(() => {
    if (data?.length === 0) {
      setInviteData([]);
      return;
    }
    if (data?.length) {
      const removeWithNoCandidate = data.filter(
        (item) => item.invitedCandidate
      );
      setInviteData(removeWithNoCandidate);
    }
  }, [data]);
  return (
    <div>
      {inviteData?.length === 0 ? (
        <Text>No Invites Sent</Text>
      ) : (
        <>
          <Box display={["none", "none", "block", "block"]}>
            <TableContainer>
              <Table>
                {/* <Thead>
                  <Tr>
                    <Td
                      fontSize={20}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                      textAlign="center"
                    >
                      Candidate
                    </Td>
                    <Td
                      fontSize={20}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                      textAlign="center"
                    >
                      Role
                    </Td>
                    <Td
                      fontSize={20}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                      textAlign="center"
                    >
                      Applied date
                    </Td>
                    <Td
                      fontSize={20}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                      textAlign="center"
                    >
                      Status
                    </Td>
                    <Td
                      fontSize={20}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                    ></Td>
                  </Tr>
                </Thead> */}
                <Tbody>
                  {inviteData?.map((elem, idx) => (
                    // Candidate Row
                    <Tr key={idx}>
                      <Td>
                        <Flex align="center" gap={5}>
                          {/* Picture */}
                          <Circle
                            size={12}
                            overflow="hidden"
                            border="1px solid #D9D9D9"
                            cursor="pointer"
                            onClick={() => {
                              navigate(
                                `/hiring/recruiter/studentprofile/${elem?.invitedCandidate._id}`
                              );
                            }}
                          >
                            {elem.invitedCandidate?.profile_photo ? (
                              <img
                                style={{ width: "100%", height: "100%" }}
                                src={elem.invitedCandidate?.profile_photo}
                                alt="student"
                              />
                            ) : (
                              <img
                                style={{ height: "100%", width: "100%" }}
                                src={
                                  "https://cdn-icons-png.flaticon.com/512/1077/1077114.png"
                                }
                                alt="student"
                              />
                            )}
                          </Circle>
                          {/* name */}
                          <Text
                            fontSize={20}
                            fontFamily={"Roboto"}
                            fontWeight={500}
                            cursor="pointer"
                            onClick={() => {
                              navigate(
                                `/hiring/recruiter/studentprofile/${elem.invitedCandidate._id}`
                              );
                            }}
                          >
                            {elem.invitedCandidate?.name}
                          </Text>
                        </Flex>
                      </Td>
                      {/* Rank */}
                      {/* <Td>
                  <Text>#{elem.rank}</Text>
                </Td> */}
                      {/* Job role */}
                      {/* <Td textAlign="center">
                        <Text fontWeight={500} fontFamily={"Roboto"}>
                          3D NFT Artist
                        </Text>
                      </Td> */}
                      {/* applied date */}
                      <Td>
                        <Text>
                          {moment(elem.createdAt).format("DD-MM-YYYY")}
                        </Text>
                      </Td>
                      {/* Status */}
                      <Td>
                        <Box>
                          <Status_Component
                            action={elem.status}
                            bg={
                              elem.status === "accepted"
                                ? "rgba(0, 212, 174, 0.14)"
                                : "rgba(255, 206, 1, 0.14)"
                            }
                          />
                        </Box>
                      </Td>
                      {/* Menu */}
                      <Td>
                        <Popover>
                          <PopoverTrigger>
                            <Circle
                              size={8}
                              border="1px solid"
                              _hover={{ background: "#D9D9D9" }}
                            >
                              <img
                                height="70%"
                                width="70%"
                                src="https://cdn-icons-png.flaticon.com/512/2311/2311524.png"
                                alt="Profile_Pic"
                              />
                            </Circle>
                          </PopoverTrigger>
                          <PopoverContent
                            w={200}
                            bg="#FFFFFF"
                            borderRadius={10}
                          >
                            <PopoverArrow bg="#FFFFFF" />
                            <PopoverCloseButton />
                            <PopoverBody>
                              <Flex flexDirection="column" my={5} gap={2}>
                                {/* Send Message */}
                                {/* <Flex align="center" gap={2} cursor="pointer">
                                  <Circle size={7} bg="#D9D9D9">
                                    <img src={message} alt="msg" />
                                  </Circle>
                                  <Box> */}
                                {/* Route to respective page */}
                                {/* <Text fontSize={18} fontWeight={400}>
                                      Send Message
                                    </Text>
                                  </Box>
                                </Flex> */}
                                <Divider border="1px solid #DEDEDE" />
                                {/* View Profile */}
                                <Flex align="center" gap={2} cursor="pointer">
                                  <Circle size={7} bg="#D9D9D9">
                                    <img src={profile} alt="profile icon" />
                                  </Circle>

                                  <Box
                                    onClick={() => {
                                      navigate(
                                        `/hiring/recruiter/studentprofile/${elem.invitedCandidate}`
                                      );
                                    }}
                                  >
                                    <Text fontSize={18} fontWeight={400}>
                                      View Profile
                                    </Text>
                                  </Box>
                                </Flex>
                              </Flex>
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>

          {/* Mobile view */}

          <Box display={["block", "block", "none", "none"]}>
            {/* <Text
              align="start"
              fontSize={20}
              fontWeight={600}
              color={"#544D5E"}
            >{`Total Invites ${inviteData.length}`}</Text> */}
            {inviteData.map((elem, idx) => (
              <Box key={idx} borderBottom={"1px solid #E7E6E8;"} px={2} py={6}>
                <Flex align={"center"} justify={"space-between"}>
                  <Flex gap={2} align={"center"}>
                    {/* profile */}
                    <Circle
                      size={12}
                      border={"1px solid"}
                      overflow="hidden"
                      onClick={() => {
                        navigate(
                          `/hiring/recruiter/studentprofile/${elem.invitedCandidate._id}`
                        );
                      }}
                    >
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={elem.invitedCandidate?.profilePhoto}
                        alt="img"
                      />
                    </Circle>
                    <Flex flexDir={"column"}>
                      {/* name */}
                      <Text
                        fontSize={16}
                        fontFamily={"Roboto"}
                        fontWeight={500}
                      >
                        {elem.invitedCandidate?.name}
                      </Text>
                      {/* date */}
                      <Text fontSize={14} color={"#9D99A3"} align={"start"}>
                        {moment(elem.createdAt).format("DD-MM-YYYY")}
                      </Text>
                    </Flex>
                  </Flex>
                  {/* menu */}

                  <Status_Component
                    action={elem.status}
                    bg={
                      elem.status === "accepted"
                        ? "rgba(0, 212, 174, 0.14)"
                        : "rgba(255, 206, 1, 0.14)"
                    }
                  />
                </Flex>
              </Box>
            ))}
          </Box>
        </>
      )}
    </div>
  );
};
export default SentInvite_Page;
